import { render, staticRenderFns } from "./DefDiff.vue?vue&type=template&id=4718eadc&scoped=true&"
import script from "./DefDiff.vue?vue&type=script&lang=js&"
export * from "./DefDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4718eadc",
  null
  
)

export default component.exports